module.exports = __webpack_public_path__ + "img/news_01.50c6cc4d.jpg";